import {
  SeatMapCabinRowSectionElement,
  SeatMapCabinRowSectionElementSeat,
} from "@duffel/api/types";

export function isSeatElement(
  element: SeatMapCabinRowSectionElement,
): element is SeatMapCabinRowSectionElementSeat {
  return element.type === "seat" || element.type === "restricted_seat_general";
}
;
import "/Users/jekri/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";